export const MIN_SIGNUP_AGE = 10;

export const latestDobForAge = (years = MIN_SIGNUP_AGE, from = new Date()) => {
  const date = new Date(
    from.getFullYear() - years,
    from.getMonth(),
    from.getDate()
  );

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${date.getFullYear()}-${month}-${day}`;
};
